/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-11 14:49:38
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-01-11 10:33:27
 * @FilePath     : /marketing-introduce-ssr/components/PageLoading/index.tsx
 * @Description  : 未添加文件描述
 */

// import { Loading } from 'antd-mobile'
import cx from 'classnames';
import React from 'react';

import errImg from '@/assets/activity/e_03.png';
import loadImg from '@/assets/loading_2.gif';
import jojoupLoadImg from '@/assets/loading_2_1.gif';
import { isJoJoUp } from '@/common/const';

import styles from './index.module.scss';

interface IProps {
  status?: 'loading' | 'fail';
  content?: any;
  title?: any;
  appName?: 'jojo' | 'jojoup';
  // loadingIcon?: boolean;
}

const PageLoading = React.memo(
  ({
    status = 'loading',
    content = '正在加载数据...',
    title = '',
    appName
  }: IProps): JSX.Element => {
    let loadingImg = isJoJoUp ? jojoupLoadImg : loadImg;
    if (appName) {
      loadingImg = appName === 'jojoup' ? jojoupLoadImg : loadImg;
    }
    return (
      <div className={styles.loading}>
        <div className={cx(styles.img, styles[status])}>
          <img src={status === 'loading' ? loadingImg : errImg} alt='' />
        </div>
        {title ? <div className={styles.title}>{title}</div> : null}
        <div className={styles.desc}>
          <span>{content || '正在加载数据...'}</span>
          {/*  {loadingIcon ? <Loading /> : ''} */}
        </div>
      </div>
    );
  }
);

export default PageLoading;
